import gql from 'graphql-tag';

export const CREATE_PROPOSAL_MENU = gql`
  mutation ($input: CreateProposalMenuInput) {
    createProposalMenu(input: $input) {
      proposalMenuId
    }
  }
`;
